import toast, { resolveValue, Toast } from 'react-hot-toast';
import clsx from 'clsx';
import Icons from 'common/components/Icons/Icons';
import { useEffect, useState } from 'react';
import { actions } from 'store/slice';
import { useDispatch } from 'react-redux';

const CustomToast = (t: Toast) => {
  const [isFirstRender, setIsFirstRender] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.addToast(t));
    if (isFirstRender) {
      setIsFirstRender(false);
    }
  }, []);
  return (
    <div
      className={clsx(
        'text-white p-5 flex gap-4 rounded-md min-h-[74px] w-2/3 max-w-lg items-center ease-in-out duration-300 transform',
        {
          'bg-toastSuccess': t.type === 'success',
          'bg-toastError': t.type === 'error',
          'scale-0': isFirstRender, // Toast sẽ zoom out khi lần đầu tiên được render
          'scale-100': !isFirstRender, // Khi render xong, nó zoom vào
        },
        !t.visible && 'hidden'
      )}
    >
      <div className="bg-white rounded-md p-1">
        {t.type === 'success' ? <Icons.toastSuccess /> : <Icons.toastError />}
      </div>
      <div className="w-full">{resolveValue(t.message, t)}</div>
      <Icons.close
        width={34}
        className="cursor-pointer"
        onClick={() => {
          toast.dismiss(t.id);
        }}
      />
    </div>
  );
};

export default CustomToast;
